import WizardStepper from './WizardStepper';

export interface JourneyProgressStepperProps {
  /** Global journey index 0–5 (map → consent). */
  activeIndex: number;
}

export default function JourneyProgressStepper({ activeIndex }: JourneyProgressStepperProps) {
  return <WizardStepper variant="journey" journeyActiveIndex={activeIndex} />;
}
